export enum AriaLiveStatus {
  ERROR = 'error',
  SUCCESS = 'success',
  WARNING = 'warning',
}
